/**
 * billingStatus.ts — Billing Phase 2
 * Overdue es un ESTADO DERIVADO de display, no un status persistido: una
 * invoice 'sent' cuyo dueDate ya pasó se muestra como 'overdue' en la UI,
 * pero la DB sigue diciendo 'sent'. Decisión deliberada: sin background job
 * que mute status, sin transición extra que deshacer si el dueDate se edita.
 * El backend acepta acciones sobre 'sent' (mark-paid, reminder) sin importar
 * si la UI la pinta como vencida.
 */

interface InvoiceStatusFields {
  status: string;
  dueDate: string | null;
}

export function isInvoiceOverdue(invoice: InvoiceStatusFields): boolean {
  if (invoice.status !== 'sent' || !invoice.dueDate) return false;
  return new Date(`${invoice.dueDate}T23:59:59`) < new Date();
}

// Status para display (pills, headers): igual al real salvo el caso derivado.
export function displayInvoiceStatus(invoice: InvoiceStatusFields): string {
  return isInvoiceOverdue(invoice) ? 'overdue' : invoice.status;
}
